/**
 * Coda locale segnalazioni tutela (localStorage + merge offline).
 */

const QUEUE_KEY = "tutela_segnalazioni_queue";

function readQueue() {
  try {
    const raw = localStorage.getItem(QUEUE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeQueue(list) {
  localStorage.setItem(QUEUE_KEY, JSON.stringify(list));
}

export function enqueueTutelaSegnalazione(entry) {
  const item = {
    id: entry.id || `tut-${Date.now().toString(36)}`,
    createdAt: entry.createdAt || new Date().toISOString(),
    synced: false,
    ...entry,
  };
  const queue = readQueue();
  queue.unshift(item);
  writeQueue(queue.slice(0, 200));
  return item;
}

export function listTutelaSegnalazioniQueue() {
  return readQueue();
}

export function markTutelaSegnalazioneSynced(id) {
  const queue = readQueue().map((q) =>
    q.id === id ? { ...q, synced: true, syncedAt: new Date().toISOString() } : q
  );
  writeQueue(queue);
}

export function mergeTutelaQueuesFromIndexedDb(idbRows) {
  if (!idbRows?.length) return;
  const existing = new Set(readQueue().map((q) => q.id));
  const merged = [...readQueue()];
  idbRows.forEach((row) => {
    if (!existing.has(row.id)) {
      merged.unshift({ ...row, source: "indexeddb" });
      existing.add(row.id);
    }
  });
  writeQueue(merged.slice(0, 200));
}
